import React, { useState } from 'react';
import { BarVisualizer } from './BarVisualizer';
import './BarVisualizerDemo.css';

export function BarVisualizerDemo({ externalState = null, showButtons = true }) {
  const [internalState, setInternalState] = useState('listening');
  const state = externalState || internalState;

  return (
    <div className="bar-visualizer-demo">
      {showButtons && (
        <div className="demo-header">
          <h2 className="demo-title">Audio Frequency Visualizer</h2>
          <p className="demo-description">
            Real-time frequency band visualization with animated state transitions
          </p>
        </div>
      )}
      
      <div className="demo-content">
        <div className="visualizer-wrapper">
          <BarVisualizer
            state={state}
            demo={true}
            barCount={20}
            minHeight={15}
            maxHeight={90}
            className="demo-visualizer"
          />
        </div>

        {showButtons && (
          <div className="state-buttons">
            <button
              className={`state-button ${state === 'connecting' ? 'active' : ''}`}
              onClick={() => setInternalState('connecting')}
            >
              Connecting
            </button>
            <button
              className={`state-button ${state === 'initializing' ? 'active' : ''}`}
              onClick={() => setInternalState('initializing')}
            >
              Initializing
            </button>
            <button
              className={`state-button ${state === 'listening' ? 'active' : ''}`}
              onClick={() => setInternalState('listening')}
            >
              Listening
            </button>
            <button
              className={`state-button ${state === 'speaking' ? 'active' : ''}`}
              onClick={() => setInternalState('speaking')}
            >
              Speaking
            </button>
            <button
              className={`state-button ${state === 'thinking' ? 'active' : ''}`}
              onClick={() => setInternalState('thinking')}
            >
              Thinking
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

